$(document).ready(function() {

    /* esc closes modal */
    $(document).bind('keydown', 'esc', function () {
        $('.modal').modal('hide');
    });

    $(document).bind('keydown', 'esc', function () {
        document.getElementById('shortcut_guide').style.display='block';
    });

    $(document).bind('keyup', 'esc', function () {
        document.getElementById('shortcut_guide').style.display='none';
    });
    /*  enter fires search */
    $('#search').on('keypress', function (e) {
        if (e.which == 13) {
            $('#_search').val($(this).val());
            $('#filter_form').submit();
        }
    });
    /* meta key actions (save etc) */
    $(window).bind('keydown', function (event) {
        if (event.ctrlKey || event.metaKey) {
            switch (String.fromCharCode(event.which).toLowerCase()) {
                case 's':
                    // cmd/ctrl + s
                    console.log('cmd/ctrl + s');
                    event.preventDefault();
                    $('#form').submit();
                    break;
            }
        }
    });

    hotkeys('esc+c', function (event, handler) {
        event.preventDefault()
        window.location.href='/candidate/listing';
    });
    hotkeys('esc+v', function (event, handler) {
        event.preventDefault()
        window.location.href='/vacancy/listing';
    });
    hotkeys('esc+r', function (event, handler) {
        event.preventDefault()
        window.location.href='/report/categories';
    });
    hotkeys('esc+space', function (event, handler) {
        event.preventDefault()
        $('#search_text').val('');
        $('#searchModal').modal('show');
        $('#search_text').focus();
    });
    hotkeys('esc+d', function (event, handler) {
        event.preventDefault()
        window.location.href='/dashboard';
    });
    hotkeys('esc+w', function (event, handler) {
        event.preventDefault()
        window.location.href='/library/forms/workflow';
    });
    hotkeys('esc+e', function (event, handler) {
        event.preventDefault()
        window.location.href='/library/emails';
    });
    hotkeys('esc+f', function (event, handler) {
        event.preventDefault()
        window.location.href='/library/files';
    });

    hotkeys('ctrl+k,command+k', function (event, handler) {
        event.preventDefault();
        $('#toolFinderModal').modal('show');
        setTimeout(function() {
            $('#toolFinderModal .tool-finder-input').focus();
        }, 200);
    });

    // Reset tool finder when modal is hidden
    $('#toolFinderModal').on('hidden.bs.modal', function () {
        Livewire.dispatch('resetToolFinder');
    });

});
/* END DOC RDY */
